import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useGetTemplateFileQuery } from "../../../../services/api/repositories/TemplateMailsRepository";

export default function PreviewModal({show,handleClose, name, uuid} : {show:boolean,handleClose:()=>void, name:string, uuid:string}) {

    const {data, isLoading, isFetching, isError } = useGetTemplateFileQuery({uuid:uuid});

    return (
        <Modal size="lg" id="templatePreviewModal" tabIndex={-1} aria-labelledby="templatePreviewModalLabel" aria-hidden="true"  show={show} onHide={()=>{handleClose()}}>
            <Modal.Header className="modal-header" closeButton={true}>
                <Modal.Title className="modal-title" id="templatePreviewModalLabel" as="h1">
                    <span className="icon"></span>
                    <span className="text">Prévisualiser le Template email</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body">
                <div className="object template">
                    <h2>
                        <span className="icon"></span>
                        <span className="text">{name}</span>
                    </h2>
                </div>
                <div className="preview-container">
                    {(isLoading || isFetching )&& <p>Chargement...</p>}
                    {isError && <p>Une erreur a été rencontrée.</p>}
                    {data && <iframe className="preview" id="templatePreview" title={name} src={`data:text/html;base64,${data.data}`}></iframe>}
                </div>
            </Modal.Body >
            <Modal.Footer className="modal-footer">
                <Button type="button" variant="secondary" className="btn-cancel" data-bs-dismiss="modal" title="Fermer" onClick={()=>{handleClose()}}>
                    <span className="icon"></span>
                    <span className="text">Fermer</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
}